import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface HeaderProps {
  className?: string;
  dataTestId?: string;
}

export const RowSidebar = ({
  children,
  className,
  dataTestId,
}: PropsWithChildren<HeaderProps>) => (
  <div
    className={classNames(
      "border-primary flex flex-row gap-x-2 border-b px-6 py-5",
      className,
    )}
    data-testid={dataTestId}
  >
    {children}
  </div>
);
